import { useEffect, useState } from "react"
import Api from "../api/api"
import { IlokAccount } from "../components/IlokAccountsCard"

// The user's iLok account rows (linked or pending), fetched once per mount —
// one cheap request per page visit, nothing to invalidate: a link made on
// the Account page shows up on the next visit. `accounts` stays undefined
// while loading and after a failure (`failed`), and callers treat "unknown"
// as "don't nag, don't block": the reminders this feeds must never get in
// the way of a purchase because of our own hiccup.
export function useIlokAccounts(accessToken: string): { accounts: IlokAccount[] | undefined, failed: boolean } {
  const [accounts, setAccounts] = useState<IlokAccount[] | undefined>(undefined)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    // empty on a hard reload before auth resolves
    if (!accessToken) return
    let cancelled = false
    Api.getIlokAccounts({ accessToken })
      .then(({ ilokAccounts }) => { if (!cancelled) setAccounts(ilokAccounts) })
      .catch(() => { if (!cancelled) setFailed(true) })
    return () => { cancelled = true }
  }, [accessToken])

  return { accounts, failed }
}
